'use strict';

var loadUrl = require('../utils').loadUrl;

/**
 * reload page
 */
function reloadPage() {
    $.spinner().stop();
    window.location.reload();
}

/**
 * Build FB urls for login and register
 * @param {number} productId 123
 */
function createFbAuthUrls(productId) {
    var fbUrlWithPid;
    var $facebookLogIn = $('.facebook-login');
    if ($facebookLogIn.length) {
        var fbLoginUrl = $facebookLogIn.attr('href');
        if (fbLoginUrl) {
            if (fbLoginUrl.includes('&pid=')) {
                fbUrlWithPid = fbLoginUrl.split('&pid=');
                fbLoginUrl = fbUrlWithPid[0];
            }
            fbLoginUrl += '&pid=' + productId;
            $facebookLogIn.attr('href', fbLoginUrl);
        }
    }

    var $facebookRegistered = $('.facebook-register');
    if ($facebookRegistered.length) {
        var fbRegisterUrl = $facebookRegistered.attr('href');
        if (fbRegisterUrl) {
            if (fbRegisterUrl.includes('&pid=')) {
                fbUrlWithPid = fbRegisterUrl.split('&pid=');
                fbRegisterUrl = fbUrlWithPid[0];
            }
            fbRegisterUrl += '&pid=' + productId;
            $facebookRegistered.attr('href', fbRegisterUrl);
        }
    }
}

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} icon - icon that was clicked to add a product to the wishlist
 */
function displayMessageAndChangeIcon(data, icon) {
    $.spinner().stop();
    var status;
    if (data.success) {
        status = 'alert-success';
        if (icon.hasClass('fa-heart-o')) {
            icon.removeClass('fa-heart-o').addClass('fa-heart');
        }
    } else {
        status = 'alert-danger';
    }

    if ($('.add-to-wishlist-messages').length === 0) {
        $('body').append(
            '<div class="add-to-wishlist-messages "></div>'
        );
    }
    $('.add-to-wishlist-messages')
        .append('<div class="add-to-wishlist-alert text-center ' + status + '">' + data.msg + '</div>');

    setTimeout(function () {
        $('.add-to-wishlist-messages').remove();
    }, 5000);
}

/**
 * @param {string} url - url for ajax
 * @param {string} requestType - request type for Ajax
 * @param {string} pid - product id
 * @param {string} optionId - option id
 * @param {string} optionVal - value of option
 * @param {string} icon - icon that was clicked to add a product to the wishlist
 * @param {boolean} add - true if added, false if removed
 */
function addorRemoveWishlistForLoggedInUser(url, requestType, pid, optionId, optionVal, icon, add) {
    $.spinner().start();
    $.ajax({
        url: url,
        type: requestType,
        dataType: 'json',
        data: {
            pid: pid,
            optionId: optionId,
            optionVal: optionVal
        },
        success: function (data) {
            displayMessageAndChangeIcon(data, icon);

            $(document).trigger('wishlist-mutation', {
                productId: pid,
                added: add || false
            });
        },
        error: function (err) {
            displayMessageAndChangeIcon(err, icon);
        }
    });
}

/**
 * Call wishlist add/remove
 * @param {boolean} add True if add to wishlist, false if not
 */
function addRemoveWishlist(add) {
    var $this = $(this);
    var icon = $this.find($('i'));
    var url = $this.data('href');
    var pid = $this.closest('.product').data('pid');
    var optionId = $this.closest('.product-detail').find('.product-option').attr('data-option-id');
    var optionVal = $this.closest('.product-detail').find('.options-select option:selected').attr('data-value-id');
    optionId = optionId || null;
    optionVal = optionVal || null;
    if (!url || !pid) {
        return;
    }
    var requestType = 'get';
    if (add) {
        requestType = 'post';
    }

    var loginUrl = $('.lg-valid').data('url');
    $.spinner().start();
    $.ajax({
        url: loginUrl,
        type: 'get',
        dataType: 'json',
        success: function (data) {
            if (data.isLoggedIn) {
                $.spinner().stop();
                addorRemoveWishlistForLoggedInUser(url, requestType, pid, optionId, optionVal, icon, add);
            } else {
                $(document).trigger('login-modal-open', ['login_popupin', 'wishlist_pgp']);
                var wishLishtHeading = $('.wishlist-heading').val();
                var $pgp = $('#unique-id-pgp');
                $pgp.modal('show').find('.modal-body').spinner().start();
                loadUrl($pgp[0]).then(function () {
                    $.spinner().stop();
                });
                $pgp.find('.login-heading').empty()
                    .html(wishLishtHeading);
                $('.wl-pid-pgp').data('pid', pid);

                createFbAuthUrls(pid);
            }
        },
        error: function () {
            reloadPage();
        }
    });
}

module.exports = {
    addToWishlist: function () {
        $('body').on('click', '.wishlistTile.add-to-wish-list', function (e) {
            e.preventDefault();
            addRemoveWishlist.call(this, true);
        });
    },

    removeFromWishlist: function () {
        $('body').on('click', '.wishlistTile.remove-from-wishlist', function (e) {
            e.preventDefault();
            addRemoveWishlist.call(this, false);
        });
    },
    initAddWishlistOnLoad: function () {
        $(function () {
            var productid = sessionStorage.getItem('pid');
            if (!productid && $('#wl-session-pid').val() !== 'null') {
                productid = $('#wl-session-pid').val();
            }
            var prodUrl = $('.wl-add-prd').data('url');

            if (productid) {
                $.spinner().start();
                $.ajax({
                    url: prodUrl,
                    type: 'POST',
                    dataType: 'json',
                    data: {
                        pid: productid,
                        optionId: null,
                        optionVal: null
                    },
                    success: function () {
                        sessionStorage.removeItem('pid');
                        reloadPage();
                    },
                    error: function () {
                        sessionStorage.removeItem('pid');
                        reloadPage();
                    }
                });
            }
        });
    },
    createFbAuthenticationUrls: createFbAuthUrls
};
